// extracted by mini-css-extract-plugin
export default {"sticker":"DevSticker-module--sticker--fa540"};